module.exports = __webpack_public_path__ + "img/only-bg.34fa41c8.svg";